var shippingAddressForm = document.querySelector("#shippingAddressForm");
var TextField3 = shippingAddressForm ? shippingAddressForm.querySelector("#TextField3") : null;

window.onload = function () {
  if (TextField3) {
    TextField3.style.display = "none";
  }
};

// Product layout 4 — feature image + thumbnail slider under main image
(function () {
  var globalHooksBound = false;
  var resizeTimer;

  function safeUnslick($el) {
    if (!$el || !$el.length || !$el.hasClass("slick-initialized")) {
      return;
    }

    try {
      if ($el[0] && $el[0].slick) {
        $el.slick("unslick");
      } else {
        $el.removeClass("slick-initialized");
      }
    } catch (err) {
      $el.removeClass("slick-initialized");
    }
  }

  function getThumbNavMetrics($nav) {
    if (!$nav || !$nav.length || !$nav.hasClass("slick-initialized")) {
      return null;
    }

    var $slides = $nav.find(".slick-slide:not(.slick-cloned)");
    var count = $slides.length;
    if (!count) {
      return null;
    }

    var $list = $nav.find(".slick-list");
    var listW = $list.width() || $nav.width() || 0;
    var slideW = $slides.first().outerWidth(true) || 0;
    if (!slideW) {
      slideW = 104;
    }

    return { count: count, listW: listW, slideW: slideW };
  }

  function allThumbsFit(metrics) {
    if (!metrics) {
      return false;
    }
    return metrics.count * metrics.slideW <= metrics.listW + 2;
  }

  function toSlideIndex(val) {
    if (typeof val === "number" && !isNaN(val)) {
      return val;
    }
    if (typeof val === "string" && val !== "") {
      var n = parseInt(val, 10);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  }

  function getActiveThumbIndex($nav) {
    var $active = $nav
      .find(".slick-slide:not(.slick-cloned) .active-thumb")
      .closest(".slick-slide");
    if ($active.length) {
      return toSlideIndex($active.data("slick-index"));
    }

    var $current = $nav.find(".slick-slide.slick-current:not(.slick-cloned)").first();
    if ($current.length) {
      return toSlideIndex($current.data("slick-index"));
    }

    if ($nav[0] && $nav[0].slick) {
      return $nav[0].slick.currentSlide || 0;
    }

    return 0;
  }

  function resetNavTrackTransform($nav) {
    if (!$nav.hasClass("bb-thumb-nav--fit")) {
      return;
    }
    var $track = $nav.find(".slick-track");
    if ($track.length) {
      $track.css("transform", "translate3d(0px, 0px, 0px)");
    }
  }

  function getMainSlideIndex($for) {
    if ($for && $for.length && $for[0] && $for[0].slick) {
      return $for[0].slick.currentSlide || 0;
    }
    return 0;
  }

  function getForFromNav($nav) {
    return $nav.closest(".product-slider.custom").find(".slider-for");
  }

  function isLayout4DesktopGallery() {
    return window.matchMedia("(min-width: 768px)").matches;
  }

  function isLayout4MobileGallery() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function setLayout4GalleryAsNavFor($for, $nav, linked) {
    if (!$for || !$for.length || !$nav || !$nav.length) {
      return;
    }
    if (!$for.hasClass("slick-initialized") || !$nav.hasClass("slick-initialized")) {
      return;
    }

    try {
      $for.slick("slickSetOption", "asNavFor", linked ? $nav : null, true);
      $nav.slick("slickSetOption", "asNavFor", linked ? $for : null, true);
    } catch (err) {
      /* ignore */
    }
  }

  function applyLayout4MobileThumbHighlight($nav, $for, slideIndex) {
    if (!$nav || !$nav.length) {
      return;
    }
    var idx =
      typeof slideIndex === "number" ? slideIndex : getMainSlideIndex($for);
    syncFitModeThumbHighlight($nav, idx);
  }

  /** Reset jquery.zoom overlay offsets on load (layout 4 desktop only). */
  function resetLayout4ZoomOverlays($wrap) {
    if (!isLayout4DesktopGallery() || !$wrap || !$wrap.length) {
      return;
    }

    $wrap.find(".product-single__photo .zoomImg").css({
      top: 0,
      left: 0,
      opacity: 0,
    });
  }

  /** Match .slick-list height to tallest slide so fade slides are not clipped. */
  function syncLayout4MainSliderHeight($for) {
    if (!isLayout4DesktopGallery() || !$for || !$for.length || !$for.hasClass("slick-initialized")) {
      return;
    }

    var maxH = 0;

    $for.find(".slick-slide:not(.slick-cloned)").each(function () {
      var h = $(this).outerHeight(true);
      if (h > maxH) {
        maxH = h;
      }
    });

    if (maxH < 1) {
      return;
    }

    $for[0].style.setProperty("--l4-main-slide-height", maxH + "px");
    $for.addClass("bb-l4-main-synced");

    try {
      $for.slick("setPosition");
    } catch (err) {
      /* ignore */
    }

    resetLayout4ZoomOverlays($for.closest(".product-slider.custom"));
  }

  function bindLayout4MainGalleryDesktopSync($wrap, $for) {
    if (!$wrap.length || !$for.length) {
      return;
    }

    $for.off(".layout4MainGallery");
    $wrap
      .find(".product-single__photo.js-zoom-enabled")
      .off(".layout4MainGallery");

    function runSync() {
      if (!isLayout4DesktopGallery()) {
        $for.removeClass("bb-l4-main-synced");
        $for[0].style.removeProperty("--l4-main-slide-height");
        return;
      }
      syncLayout4MainSliderHeight($for);
      resetLayout4ZoomOverlays($wrap);
    }

    $for.find("img.product-featured-img").each(function () {
      if (this.complete) {
        return;
      }
      $(this).one("load error", runSync);
    });

    runSync();

    $(window)
      .off("resize.layout4MainGallery")
      .on("resize.layout4MainGallery", debounceLayout4(runSync, 180));

    $for.on(
      "afterChange.layout4MainGallery init.layout4MainGallery reInit.layout4MainGallery",
      runSync
    );

    $wrap
      .find(".product-single__photo.js-zoom-enabled")
      .on("mouseenter.layout4MainGallery", function () {
        var $zoomImg = $(this).find(".zoomImg");
        if ($zoomImg.length) {
          $zoomImg.css("opacity", "");
        }
      })
      .on("mouseleave.layout4MainGallery", function () {
        $(this).find(".zoomImg").css({ top: 0, left: 0, opacity: 0 });
      });
  }

  var layout4MainGalleryResizeTimer;

  function debounceLayout4(fn, wait) {
    return function () {
      clearTimeout(layout4MainGalleryResizeTimer);
      layout4MainGalleryResizeTimer = setTimeout(fn, wait);
    };
  }

  /** Fit mode: one red border via .active-thumb only — do not drive selection with slickGoTo(0). */
  function syncFitModeThumbHighlight($nav, slideIndex) {
    var index = toSlideIndex(slideIndex);
    if (!$nav || !$nav.length) {
      return;
    }

    $nav.find(".product-single__thumbnail--product-template, .product-single__thumbnail").each(
      function () {
        $(this).removeClass("active-thumb").removeAttr("aria-current");
      }
    );

    var $slide = $nav
      .find(".slick-slide:not(.slick-cloned)")
      .filter(function () {
        return toSlideIndex($(this).data("slick-index")) === index;
      })
      .first();

    if ($slide.length) {
      var $thumb = $slide.find(".product-single__thumbnail").first();
      $thumb.addClass("active-thumb");
      $thumb.attr("aria-current", "true");
    }
  }

  function applyScrollableThumbNav($nav) {
    if (isLayout4MobileGallery()) {
      return;
    }

    $nav.removeClass("bb-thumb-nav--fit");

    var metrics = getThumbNavMetrics($nav);
    if (!metrics || !$nav[0] || !$nav[0].slick || !$nav[0].slick.options) {
      return;
    }

    var activeIndex = getActiveThumbIndex($nav);
    var slidesToShow = $nav[0].slick.options.slidesToShow || 1;
    var currentSlide = $nav[0].slick.currentSlide || 0;
    var visibleEnd = currentSlide + slidesToShow - 1;

    if (activeIndex < currentSlide || activeIndex > visibleEnd) {
      try {
        $nav.slick("slickGoTo", activeIndex, true);
      } catch (err) {
        /* ignore */
      }
    }
  }

  function applyCenteredThumbNav($nav, $for) {
    if (isLayout4MobileGallery()) {
      return;
    }

    if ($nav.data("bb-center-lock")) {
      return;
    }

    var metrics = getThumbNavMetrics($nav);
    if (!metrics || !allThumbsFit(metrics)) {
      applyScrollableThumbNav($nav);
      return;
    }

    $nav.addClass("bb-thumb-nav--fit");
    $nav.data("bb-center-lock", true);

    try {
      if (typeof $nav.slick === "function") {
        /* Temporarily remove asNavFor so changing slidesToShow does not
           trigger slickGoTo(0) on the main image slider. */
        var currentAsNavFor = $nav[0].slick.options.asNavFor;
        $nav.slick("slickSetOption", "asNavFor", null, false);
        $nav.slick("slickSetOption", "slidesToShow", metrics.count, false);
        $nav.slick("slickSetOption", "slidesToScroll", 1, false);
        $nav.slick("slickSetOption", "asNavFor", currentAsNavFor, true);
      }
    } catch (err) {
      /* ignore */
    }

    resetNavTrackTransform($nav);
    syncFitModeThumbHighlight($nav, getMainSlideIndex($for));

    requestAnimationFrame(function () {
      try {
        if ($nav.length && $nav.hasClass("slick-initialized") && typeof $nav.slick === "function") {
          $nav.slick("setPosition");
        }
      } catch (err) {
        /* ignore */
      }
      resetNavTrackTransform($nav);
      syncFitModeThumbHighlight($nav, getMainSlideIndex($for));
      $nav.data("bb-center-lock", false);
    });
  }

  function centerLayout4ThumbNav($nav, $for) {
    if (!$nav || !$nav.length || !$nav.hasClass("slick-initialized")) {
      return;
    }

    if (isLayout4MobileGallery()) {
      return;
    }

    if (!$for || !$for.length) {
      $for = getForFromNav($nav);
    }

    var metrics = getThumbNavMetrics($nav);
    if (metrics && allThumbsFit(metrics)) {
      applyCenteredThumbNav($nav, $for);
    } else {
      applyScrollableThumbNav($nav);
    }
  }

  function computeSlidesToShow($nav, thumbCount, max) {
    var listW = $nav.width() || $nav.outerWidth() || 0;
    var approxThumb = 104;
    var fit = Math.max(1, Math.floor(listW / approxThumb));
    return Math.max(1, Math.min(max, thumbCount, fit));
  }

  function wireThumbNavCentering($nav, $for) {
    $nav.off(".bbThumbCenter");
    if ($for && $for.length) {
      $for.off(".bbThumbCenter");
    }

    /* Do not call applyCenteredThumbNav from setPosition/afterChange — it calls setPosition and causes a feedback loop. */
    $nav.on("init.bbThumbCenter reInit.bbThumbCenter", function () {
      setTimeout(function () {
        if (isLayout4MobileGallery()) {
          applyLayout4MobileThumbHighlight($nav, $for);
          return;
        }
        centerLayout4ThumbNav($nav, $for);
      }, 0);
    });

    $nav.on("setPosition.bbThumbCenter afterChange.bbThumbCenter", function (e, slick, currentSlide) {
      if ($nav.data("bb-center-lock")) {
        return;
      }
      if (isLayout4MobileGallery()) {
        var navIdx =
          typeof currentSlide === "number"
            ? currentSlide
            : $nav[0] && $nav[0].slick
              ? $nav[0].slick.currentSlide
              : getMainSlideIndex($for);
        applyLayout4MobileThumbHighlight($nav, $for, navIdx);
        return;
      }
      if ($nav.hasClass("bb-thumb-nav--fit")) {
        resetNavTrackTransform($nav);
        var idx =
          typeof currentSlide === "number"
            ? currentSlide
            : $nav[0] && $nav[0].slick
              ? $nav[0].slick.currentSlide
              : getMainSlideIndex($for);
        syncFitModeThumbHighlight($nav, idx);
      }
    });

    if ($for && $for.length) {
      $for.on("afterChange.bbThumbCenter", function (e, slick, currentSlide) {
        if ($nav.data("bb-center-lock")) {
          return;
        }
        if (isLayout4MobileGallery()) {
          applyLayout4MobileThumbHighlight(
            $nav,
            $for,
            typeof currentSlide === "number" ? currentSlide : getMainSlideIndex($for)
          );
          return;
        }
        if ($nav.hasClass("bb-thumb-nav--fit")) {
          resetNavTrackTransform($nav);
          syncFitModeThumbHighlight(
            $nav,
            typeof currentSlide === "number" ? currentSlide : getMainSlideIndex($for)
          );
        } else {
          centerLayout4ThumbNav($nav, $for);
        }
      });
    }
  }

  function bindGlobalThumbNavHooks($) {
    if (globalHooksBound) {
      return;
    }
    globalHooksBound = true;

    $(window).on("resize.bbThumbCenter", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        $(".product-layout-4 .product-slider.custom .slider-nav.slick-initialized").each(
          function () {
            var $nav = $(this);
            var $for = getForFromNav($nav);
            if (isLayout4MobileGallery()) {
              $nav.removeClass("bb-thumb-nav--fit");
              setLayout4GalleryAsNavFor($for, $nav, false);
              applyLayout4MobileThumbHighlight($nav, $for);
              return;
            }
            setLayout4GalleryAsNavFor($for, $nav, true);
            try {
              $nav.slick("setPosition");
            } catch (err) {
              /* ignore */
            }
            centerLayout4ThumbNav($nav, $for);
          }
        );
      }, 180);
    });

    $(window).on("load.bbThumbCenter", function () {
      $(".product-layout-4 .product-slider.custom .slider-nav.slick-initialized").each(
        function () {
          var $nav = $(this);
          var $for = getForFromNav($nav);
          if (isLayout4MobileGallery()) {
            setLayout4GalleryAsNavFor($for, $nav, false);
            applyLayout4MobileThumbHighlight($nav, $for);
            return;
          }
          setLayout4GalleryAsNavFor($for, $nav, true);
          try {
            $nav.slick("setPosition");
          } catch (err) {
            /* ignore */
          }
          centerLayout4ThumbNav($nav, $for);
        }
      );
    });

    /* Theme uses namespaced triggers, e.g. variantImageChange.slideshow-{id}; bind base name so delegation receives bubbled events. */
    $(document).on(
      "variantImageChange",
      ".product-layout-4 [data-section-type='product']",
      function () {
        var $section = $(this);
        setTimeout(function () {
          $section.find(".slider-nav.slick-initialized").each(function () {
            var $nav = $(this);
            var $for = getForFromNav($nav);
            if (isLayout4MobileGallery()) {
              applyLayout4MobileThumbHighlight($nav, $for);
              return;
            }
            centerLayout4ThumbNav($nav, $for);
          });
        }, 350);
      }
    );
  }

  function initProductLayout4Gallery($) {
    var $layouts = $(".product-layout-4 .product-slider.custom");
    if (!$layouts.length) return;

    bindGlobalThumbNavHooks($);

    $layouts.each(function () {
      var $wrap = $(this);
      var $for = $wrap.find(".slider-for");
      var $nav = $wrap.find(".slider-nav");

      if (!$for.length || !$nav.length) {
        return;
      }

      // Destroy stale instances before re-init (handles theme editor reloads)
      safeUnslick($for);
      safeUnslick($nav);
      $nav.removeClass("bb-thumb-nav--fit");

      // Main (feature) image — fade, no arrows, synced to nav
      $for.slick({
        fade: true,
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: $nav,
        adaptiveHeight: false,
        waitForAnimate: false,
      });

      // Thumbnail nav — horizontal row below main image (aligned with main stage)
      var thumbCount = $nav.children(".product-single__thumbnails-item, .item").length;
      if (!thumbCount) {
        thumbCount = $nav.children().length;
      }

      function capSlides(n) {
        return computeSlidesToShow($nav, thumbCount, n);
      }

      $nav.slick({
        rows: 0,
        arrows: false,
        infinite: false,
        variableWidth: false,
        initialSlide: 0,
        slidesToShow: capSlides(5),
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: $for,
        responsive: [
          { breakpoint: 1440, settings: { slidesToShow: capSlides(5), arrows: false } },
          { breakpoint: 1280, settings: { slidesToShow: capSlides(4), arrows: false } },
          { breakpoint: 1024, settings: { slidesToShow: capSlides(5), arrows: false } },
          { breakpoint: 768, settings: { slidesToShow: capSlides(4), arrows: false } },
          { breakpoint: 400, settings: { slidesToShow: capSlides(3), arrows: false } },
        ],
      });

      wireThumbNavCentering($nav, $for);

      if (isLayout4MobileGallery()) {
        setLayout4GalleryAsNavFor($for, $nav, false);
        applyLayout4MobileThumbHighlight($nav, $for);
      } else {
        centerLayout4ThumbNav($nav, $for);
      }

      bindLayout4MainGalleryDesktopSync($wrap, $for);

      requestAnimationFrame(function () {
        if (isLayout4MobileGallery()) {
          applyLayout4MobileThumbHighlight($nav, $for);
          return;
        }
        try {
          $nav.slick("setPosition");
        } catch (err) {
          /* ignore */
        }
        centerLayout4ThumbNav($nav, $for);
      });

      setTimeout(function () {
        if (isLayout4MobileGallery()) {
          applyLayout4MobileThumbHighlight($nav, $for);
          return;
        }
        centerLayout4ThumbNav($nav, $for);
        syncLayout4MainSliderHeight($for);
        resetLayout4ZoomOverlays($wrap);
      }, 400);

      /* After theme _setActiveThumbnail slickGoTo (~300ms), keep row centered + correct highlight */
      setTimeout(function () {
        if (isLayout4MobileGallery()) {
          applyLayout4MobileThumbHighlight($nav, $for);
          return;
        }
        if ($nav.hasClass("bb-thumb-nav--fit")) {
          resetNavTrackTransform($nav);
          syncFitModeThumbHighlight($nav, getMainSlideIndex($for));
        }
        syncLayout4MainSliderHeight($for);
        resetLayout4ZoomOverlays($wrap);
      }, 450);
    });

    if (typeof theme !== "undefined" && typeof theme.initLayout4MobileGallery === "function") {
      setTimeout(function () {
        theme.initLayout4MobileGallery();
      }, 0);
    }

    if (typeof theme !== "undefined" && typeof theme.initLayout4PriceBlock === "function") {
      setTimeout(function () {
        theme.initLayout4PriceBlock();
      }, 0);
    }

    if (typeof theme !== "undefined" && typeof theme.initLayout4Inventory === "function") {
      setTimeout(function () {
        theme.initLayout4Inventory();
      }, 0);
    }
  }

  function whenReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // Slick lives in vendor.js which is deferred and loaded AFTER this file.
  // Wait until both jQuery and $.fn.slick exist before initializing.
  function waitForJqueryAndSlick(triesLeft) {
    var $ = window.jQuery;
    if ($ && $.fn && typeof $.fn.slick === "function") {
      initProductLayout4Gallery($);
      return;
    }

    if (triesLeft <= 0) return;
    setTimeout(function () {
      waitForJqueryAndSlick(triesLeft - 1);
    }, 100);
  }

  whenReady(function () {
    waitForJqueryAndSlick(50); // ~5s max
  });
})();

// Layout 4 — Buy It Now: beat theme grey inject; hover via listeners (not constant inline reset)
(function () {
  var BUY_NOW_SEL =
    ".product-layout-4 .shopify-payment-button__button--unbranded";

  function setBuyNowNormal(btn) {
    btn.style.setProperty("background-color", "#ffffff", "important");
    btn.style.setProperty("background", "#ffffff", "important");
    btn.style.setProperty("color", "#B90C09", "important");
    btn.style.setProperty("-webkit-text-fill-color", "#B90C09", "important");
    btn.style.setProperty("border", "1px solid #B90C09", "important");
    btn.style.setProperty("border-bottom", "1px solid #B90C09", "important");
    btn.style.setProperty("box-shadow", "none", "important");
  }

  function setBuyNowHover(btn) {
    btn.style.setProperty("background-color", "#B90C09", "important");
    btn.style.setProperty("background", "#B90C09", "important");
    btn.style.setProperty("color", "#ffffff", "important");
    btn.style.setProperty("-webkit-text-fill-color", "#ffffff", "important");
    btn.style.setProperty("border-color", "#B90C09", "important");
    btn.style.setProperty("border-bottom-color", "#B90C09", "important");
  }

  function bindBuyItNowButton(btn) {
    if (!btn || btn.dataset.bbBuyNowBound === "1") return;
    btn.dataset.bbBuyNowBound = "1";
    btn.classList.add("bb-buy-now-btn");

    setBuyNowNormal(btn);

    btn.addEventListener("mouseenter", function () {
      setBuyNowHover(btn);
    });
    btn.addEventListener("mouseleave", function () {
      setBuyNowNormal(btn);
    });
    btn.addEventListener("focus", function () {
      setBuyNowHover(btn);
    });
    btn.addEventListener("blur", function () {
      setBuyNowNormal(btn);
    });
  }

  function scanBuyItNow(root) {
    var scope = root || document;
    scope.querySelectorAll(BUY_NOW_SEL).forEach(bindBuyItNowButton);
  }

  function watchBuyItNow() {
    scanBuyItNow();
    var host = document.querySelector(".product-layout-4 .pf-buy-now");
    if (!host || host.__bbBuyNowObserved) return;
    host.__bbBuyNowObserved = true;
    var obs = new MutationObserver(function () {
      scanBuyItNow(host);
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchBuyItNow);
  } else {
    watchBuyItNow();
  }

  document.addEventListener("shopify:section:load", watchBuyItNow);
})();
(function () {
  function copyText(text) {
    if (!text) {
      return Promise.reject(new Error("empty"));
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var ok = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (ok) {
          resolve();
        } else {
          reject(new Error("copy failed"));
        }
      } catch (err) {
        document.body.removeChild(textarea);
        reject(err);
      }
    });
  }

  function getLiveRegion(toolbox) {
    if (!toolbox) {
      return null;
    }
    return toolbox.querySelector(".share_toolbox__live");
  }

  function showCopiedFeedback(trigger, toolbox, copiedLabel) {
    var defaultAria = trigger.getAttribute("data-default-aria-label") || "";
    var defaultTitle = trigger.getAttribute("data-default-title") || "";
    var live = getLiveRegion(toolbox);

    trigger.classList.add("is-copied");
    trigger.setAttribute("aria-label", copiedLabel);
    trigger.setAttribute("title", copiedLabel);
    if (live) {
      live.textContent = copiedLabel;
    }

    if (trigger._nativeShareResetTimer) {
      clearTimeout(trigger._nativeShareResetTimer);
    }

    trigger._nativeShareResetTimer = setTimeout(function () {
      trigger.classList.remove("is-copied");
      if (defaultAria) {
        trigger.setAttribute("aria-label", defaultAria);
      } else {
        trigger.removeAttribute("aria-label");
      }
      if (defaultTitle) {
        trigger.setAttribute("title", defaultTitle);
      } else {
        trigger.removeAttribute("title");
      }
      if (live) {
        live.textContent = "";
      }
    }, 2000);
  }

  function handleNativeShare(trigger) {
    var shareUrl = trigger.dataset.shareUrl;
    var shareTitle = trigger.dataset.shareTitle || document.title;
    var shareDescription = trigger.dataset.shareDescription || shareTitle;
    var copiedLabel = trigger.dataset.copiedLabel || "Link copied";
    if (!shareUrl) {
      return;
    }

    var toolbox = trigger.closest(".share_toolbox--native");

    function runCopyFallback() {
      return copyText(shareUrl)
        .then(function () {
          showCopiedFeedback(trigger, toolbox, copiedLabel);
        })
        .catch(function () {
          /* clipboard blocked — fail silently */
        });
    }

    if (navigator.share) {
      navigator
        .share({
          title: shareTitle,
          text: shareDescription,
          url: shareUrl,
        })
        .then(function () {
          /* shared via OS / browser sheet */
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") {
            return;
          }
          return runCopyFallback();
        });
    } else {
      runCopyFallback();
    }
  }

  function initShareToolboxNativeShare() {
    document.addEventListener("click", function (evt) {
      var trigger = evt.target.closest(".share_toolbox__link--native-share");
      if (!trigger) {
        return;
      }

      evt.preventDefault();
      handleNativeShare(trigger);
    });

    document.addEventListener("keydown", function (evt) {
      if (evt.key !== " " && evt.key !== "Spacebar") {
        return;
      }
      var trigger = evt.target.closest(".share_toolbox__link--native-share");
      if (!trigger) {
        return;
      }
      evt.preventDefault();
      handleNativeShare(trigger);
    });

    document
      .querySelectorAll(".share_toolbox__link--native-share")
      .forEach(function (trigger) {
        var aria = trigger.getAttribute("aria-label");
        if (aria) {
          trigger.setAttribute("data-default-aria-label", aria);
        }
        var title = trigger.getAttribute("title");
        if (title) {
          trigger.setAttribute("data-default-title", title);
        }
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShareToolboxNativeShare);
  } else {
    initShareToolboxNativeShare();
  }
})();

function initHeaderLangSwitch() {
  var flagEl = document.getElementById('headerLangFlag');
  var textEl = document.getElementById('headerLangText');
  var btn    = document.getElementById('headerLangSwitch');

  if (!flagEl || !textEl || !btn) return;

  var origin = window.location.origin;
  var path = window.location.pathname || '/';
  var search = window.location.search || '';
  var hash = window.location.hash || '';

  function stripTrailingSlash(p) {
    if (!p || p === '/') return '/';
    return p.replace(/\/+$/, '') || '/';
  }

  function saveLangPreference(lang) {
    try {
      localStorage.setItem('bb-lang', lang);
      localStorage.setItem('translation-lab-lang', lang);
      document.cookie = 'bb_lang=' + lang + ';path=/;max-age=31536000;SameSite=Lax';
    } catch (e) {}
  }

  path = stripTrailingSlash(path);
  var isEn = path === '/en' || path.indexOf('/en/') === 0;

  function toArabicPath(enPath) {
    var next = enPath.replace(/^\/en(?=\/|$)/, '') || '/';
    return stripTrailingSlash(next);
  }

  function toEnglishPath(arPath) {
    if (arPath === '/') return '/en';
    return '/en' + stripTrailingSlash(arPath);
  }

  var nextLang;
  var nextUrl;

  if (isEn) {
    flagEl.src = 'https://img.icons8.com/color/48/000000/saudi-arabia-circular.png';
    flagEl.alt = 'ar';
    textEl.textContent = 'العربية';
    nextLang = 'ar';
    nextUrl = origin + toArabicPath(path) + search + hash;
  } else {
    flagEl.src = 'https://img.icons8.com/color/96/000000/usa-circular.png';
    flagEl.alt = 'en';
    textEl.textContent = 'English';
    nextLang = 'en';
    nextUrl = origin + toEnglishPath(path) + search + hash;
  }

  btn.href = nextUrl;
  btn.setAttribute('data-bb-next-lang', nextLang);

  if (btn.dataset.bbLangBound === '1') return;
  btn.dataset.bbLangBound = '1';

  btn.addEventListener('click', function (e) {
    var lang = btn.getAttribute('data-bb-next-lang') || nextLang;
    saveLangPreference(lang);
    // Prefer full navigation so preference is saved before leaving
    if (btn.href && btn.href !== '#' && btn.href.indexOf('javascript:') !== 0) {
      e.preventDefault();
      window.location.assign(btn.href);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderLangSwitch);
} else {
  initHeaderLangSwitch();
}

(function () {
  function unveilLazyImages(container) {
    if (!window.lazySizes || !container) return;
    var imgs = container.querySelectorAll("img.lazyload, img.lazyautosizes");
    imgs.forEach(function (img) {
      try {
        if (lazySizes.loader && lazySizes.loader.unveil) {
          lazySizes.loader.unveil(img);
        } else if (lazySizes.unveil) {
          lazySizes.unveil(img);
        }
      } catch (e) {}
    });
    if (lazySizes.autoSizer && lazySizes.autoSizer.checkElems) {
      try {
        lazySizes.autoSizer.checkElems();
      } catch (e) {}
    }
  }

  function forceLoadImages(container) {
    if (!container) return;
    container.querySelectorAll("img[data-src]").forEach(function (img) {
      if (img.classList.contains("lazyloaded")) return;
      var src = img.getAttribute("src") || "";
      if (src.indexOf("_90x") === -1 && src.indexOf("90x") === -1) return;

      var dataSrc = img.getAttribute("data-src");
      if (!dataSrc) return;

      if (dataSrc.indexOf("{width}") > -1) {
        dataSrc = dataSrc.replace(/\{width\}/g, "360");
      }
      img.src = dataSrc;

      var dataSrcset = img.getAttribute("data-srcset");
      if (dataSrcset) {
        if (dataSrcset.indexOf("{width}") > -1) {
          dataSrcset = dataSrcset.replace(/\{width\}/g, "360");
        }
        img.setAttribute("srcset", dataSrcset);
      }

      img.classList.add("lazyloaded");
      img.classList.remove("lazyload", "lazyautosizes");
    });
  }

  function loadLazyInContainer(container) {
    if (!container) return;
    unveilLazyImages(container);
    forceLoadImages(container);
  }

  var searchDebounce;
  function debouncedSearchLoad(container) {
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(function () {
      loadLazyInContainer(container);
    }, 50);
  }

  function initSearchHooks() {
    document.addEventListener("focusin", function (e) {
      if (!e.target || !e.target.matches || !e.target.matches(".header-search__input")) {
        return;
      }
      var wrap = document.querySelector(".quickSearchResultsWrap");
      if (wrap) loadLazyInContainer(wrap);
    });

    var wrap = document.querySelector(".quickSearchResultsWrap");
    if (wrap) {
      new MutationObserver(function () {
        debouncedSearchLoad(wrap);
      }).observe(wrap, { childList: true, subtree: true });
    }
  }

  function refreshFeaturedCarousel(carousel) {
    if (!carousel || typeof jQuery === "undefined") return;
    var $carousel = jQuery(carousel);
    if (!$carousel.hasClass("slick-initialized")) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        try {
          var slick = carousel.slick;
          if (slick && typeof slick.setPosition === "function") {
            slick.setPosition();
          } else {
            $carousel.slick("setPosition");
          }
        } catch (e) {}
      });
    });
  }

  function initMegaMenuHooks() {
    document.querySelectorAll(".site-nav > li.mega-menu").forEach(function (li) {
      li.addEventListener("mouseenter", function () {
        var panel = li.querySelector(".sub-menu-mobile");
        var carousel = li.querySelector(".featuredProductCarousel");
        if (panel) loadLazyInContainer(panel);
        if (carousel) {
          loadLazyInContainer(carousel);
          refreshFeaturedCarousel(carousel);
        }
      });
    });

    document.querySelectorAll(".mega-menu").forEach(function (el) {
      el.addEventListener("mouseenter", function () {
        var panel = el.querySelector(".sub-menu-mobile");
        var carousel = el.querySelector(".featuredProductCarousel");
        if (panel) loadLazyInContainer(panel);
        if (carousel) {
          loadLazyInContainer(carousel);
          refreshFeaturedCarousel(carousel);
        }
      });
    });

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest(
        ".nav-action.menu__moblie, [data-toggle-menu-mb], .menu-mb-title"
      );
      if (!trigger) return;
      var li = trigger.closest("li");
      if (!li) return;
      var carousel = li.querySelector(".featuredProductCarousel");
      if (carousel) {
        loadLazyInContainer(carousel);
        refreshFeaturedCarousel(carousel);
      }
    });
  }

  function initSlickHooks() {
    if (typeof jQuery === "undefined") return;
    var $ = jQuery;
    var events = "init afterChange setPosition";
    $(document).on(events, ".featuredProductCarousel", function () {
      loadLazyInContainer(this);
      this.querySelectorAll(".slick-slide").forEach(function (slide) {
        loadLazyInContainer(slide);
      });
    });
  }

  function init() {
    initSearchHooks();
    initMegaMenuHooks();
    initSlickHooks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
